import api from './api'

class TargetService {
  // Get all targets
  async getAllTargets(params = {}) {
    try {
      const response = await api.get('/hr/targets', { params })
      console.log('Raw API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data,
        message: response.data.message || 'Targets retrieved successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to retrieve targets',
        error: error.response?.data
      }
    }
  }

  // Get target by ID
  async getTargetById(targetId) {
    try {
      const response = await api.get(`/hr/targets/${targetId}`)
      console.log('Raw GET by ID API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data.target || data,
        message: response.data.message || 'Target retrieved successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to retrieve target',
        error: error.response?.data
      }
    }
  }

  // Create new target
  async createTarget(targetData) {
    try {
      const response = await api.post('/hr/targets', targetData)
      console.log('Raw POST API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data.target || data,
        message: response.data.message || 'Target created successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create target',
        error: error.response?.data
      }
    }
  }

  // Update target
  async updateTarget(targetId, targetData) {
    try {
      const response = await api.patch(`/hr/targets/${targetId}`, targetData)
      console.log('Raw PATCH API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data.target || data,
        message: response.data.message || 'Target updated successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update target',
        error: error.response?.data
      }
    }
  }

  // Delete target
  async deleteTarget(targetId) {
    try {
      const response = await api.delete(`/hr/targets/${targetId}`)
      return {
        success: true,
        message: response.data.message || 'Target deleted successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete target',
        error: error.response?.data
      }
    }
  }
}

const targetService = new TargetService()
export default targetService
